import { render, staticRenderFns } from "./manageOrder.vue?vue&type=template&id=0740d8d2&"
import script from "./manageOrder.vue?vue&type=script&lang=js&"
export * from "./manageOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports